import { inject} from 'aurelia-framework';
import { Router } from 'aurelia-router'
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import { BackgroundMusicAPI } from '../../services/backgroundMusicAPI';
import { TestimonialRequestAPI } from '../../services/testimonialRequestAPI';
import { TestimonialLinkSubmissionAPI } from '../../services/testimonialLinkSubmissionAPI';
import { BrandVideoAPI } from '../../services/brandVideoAPI';
import {VideoDetailsBase} from '../base/video';
import { FontAPI } from '../../services/fontAPI';
import { AccountAPI } from '../../services/accountAPI';
import { EnvironmentService } from '../../services/environmentService';
import { TranscriptGenerator } from "../../services/transcriptGenerator";
import { ChatBotAPI } from '../../services/chatBotAPI';
@inject(AuthService, UserMessageService, Router, BackgroundMusicAPI, FontAPI, AccountAPI, EnvironmentService, TranscriptGenerator, ChatBotAPI)
export class VideoDetails extends VideoDetailsBase {
    constructor(authService, userMessageService, router, bgMusicApi, fontApi, accountApi, envService, transcriptGenerator,chatBotAPI) {
        super(authService, userMessageService, router, bgMusicApi, fontApi, accountApi, "api", TestimonialRequestAPI, TestimonialLinkSubmissionAPI, BrandVideoAPI, envService, false, transcriptGenerator, chatBotAPI);
        this.dashboardlength = 'col-sm-12';
        this.isdashboard = false;
    }
    onNavigate() {
        this.navPanelClass = '';
      }


      reproduce(setReady = false) {
        this.saving = true;
        var data = this.getData();
        data.set_ready = setReady;
        this.api.reproduce(
            data,
            (this.cta_files && this.cta_files.length > 0 && this.showCTAUpload ? this.cta_files[0] : null),
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }

    formatBytes(bytes, decimals = 2) {
      if (bytes === 0 || bytes == null) return "0 KB";
  
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  
      const i = Math.floor(Math.log(bytes) / Math.log(k));
  
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }
    recreate() {

      if (confirm("Are you sure you want to re-create this video?")) {
        if (this.validate()) {
          if (this.enableSubtitle) {
            if (this.subtitles.caption.length == 0) {
              this.userMessageService.setUserError(
                "user",
                "Subtitles are empty."
              );
              return;
            }
            this.subtitles.styles = this.transcriptGenerator.selectedStyle
            ? this.transcriptGenerator.selectedStyle
            : this.transcriptGenerator.styles[0]; //settting default styles

          }

          this.saving = true;
          var data = this.getData();
          this.api.recreate(
              data,
              (this.cta_files && this.cta_files.length > 0 && this.showCTAUpload ? this.cta_files[0] : null),
              this.authService.getUser().token,
              this.saveLoadSuccess.bind(this),
              this.saveLoadError.bind(this));

        }

        if (this.run_once) {
          console.log("Run Once:::");
          $("#progressbar").progressbar("value", 0);
          setTimeout(this.progress.bind(this), 18000);
          this.run_once = false;
        }
      }

    }

    navigateLink(route, replace = false) {
        console.log("route param123444",route);
        localStorage.setItem('rout', route);
        if(route.includes("#/user/video/email"))
        {
          if(route.includes("upload"))
          route = route + "?captureType=3" + "?videoUpload=1";
          else
          route = route + "?captureType=3";
          // window.location.h  ref = "Posts?Category=" + sel;
        }
        if(route.includes("#/user/home") || route == "#/user" || route === "#/user/video/request" || route === "#/user/video/caseStudy" || route.includes("#/user/video/email"))
        {
          this.isdashboard = true;
          this.dashboardlength = 'col-sm-12';
          console.log("Dashboard value is",this.isdashboard);
          // window.location.href = "Posts?Category=" + sel;
        }
        else
        {
          this.isdashboard = false;
          this.dashboardlength = 'col-sm-9';
          console.log("Dashboard value is",this.isdashboard);
        }
        this.router.navigate(route, { replace: replace });
        this.onNavigate();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }

      createBrandedVideo() {
        this.navigateLink('#/user/videos');
        window.open(window.site_url+"#/capture/brand/"+this.captureKey, "_blank");

        // href.bind="'#/capture/brand/' + captureKey"

      }

      closeTip()
      {
        $(".main-message").hide();
      }
}
